import React from 'react'
import Modal from '@material-ui/core/Modal'
import styles from './styles.module.css'
import TextField from '@material-ui/core/TextField'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from '@material-ui/core/IconButton' 
import axios from 'axios'

import Checkbox from '@material-ui/core/Checkbox';
// import TextField from '@mui/material/TextField';
// import Autocomplete from '@material-ui/core/Autocomplete';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Dialog from '@material-ui/core/Dialog';
import {connect} from 'react-redux'; 
import InputAdornment from '@material-ui/core/InputAdornment'
import SelectComp from '../../utils/Select/SelectComp';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core/styles";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes'; 
import {getCategory} from '../../../containers/app/actions';
import {withRouter} from 'react-router-dom';
import {getActiveCategory,getActiveProducts,getAllPartners,deleteCoupon, addCoupon} from '../Coupon.api';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const ConfCoupon = (props) => {
    const [selectedUsers, setSelectedUsers] = React.useState([]);
    const [userList, setUserList] = React.useState([]);
    const [selectedProducts, setSelectedProducts] = React.useState([]);
    const [productList, setProductList] = React.useState([]);
    const [selectedCategories, setSelectedCategories] = React.useState([]);
    const [categoriesList, setCategoriesList] = React.useState(props.category);
    const [selectedStartDate, setDate] = React.useState(moment());
    const [selectedApplyType, setSelectedApplyType] = React.useState(null);
    const [loadingUser,setLoadingUser]= React.useState(false);
    const [loadingProducts,setLoadingProducts]= React.useState(false);
    const [loadingCategory,setLoadingCategory]= React.useState(false);
    const [inputValue, setInputValue] = React.useState(
        moment().format("YYYY-MM-DD")
    );
    const [selectedEndDate, setEndDate] = React.useState(moment());
    
    const [inputEndValue, setInputEndValue] = React.useState(
        moment().format("YYYY-MM-DD")
    );
    const dateFormatter = (str) => {
        return str;
    };
    const [formData,setFormData] = React.useState({
        couponId: "",
        couponCode:"",
        couponType:"FLAT",
        discountAmount:0,
        discountPercentage:0,
        startDate:"",
        expiryDate:"",
        usageLimit:1,
        couponDescription:"",
        minOrderAmount:"",
        maxDiscountAmount:"",
        userId: props.user._id,
        status:"Active",
    }); 

    const [loading,setLoading] = React.useState(false) 
    const [err,setErr] = React.useState({gst: false,name: false})

    React.useEffect(() => {
        if(props.type == "EDIT") { 
            setFormData({...formData,...props.coupon,couponId: props.coupon._id});
            var sdate = moment(props.coupon.startDate).format('DD-mm-yyyy');
            var startDate = sdate;
            var date = moment(props.coupon.expiryDate).format('DD-mm-yyyy');
            var expiryDate = date;
            setInputValue(startDate);
            setInputEndValue(expiryDate);
        } 
    },[props.coupon]); 
    React.useEffect(() => {
        setLoadingUser(true);
        getAllPartners().then((res) => {
            console.log("hiii")
            console.log(res.data); 
            setUserList(res.data);
            setSelectedApplyType(1);
            setLoadingUser(false);
        }).catch(err=>console.log(err))
    },[]);
    React.useEffect(() => {
        getActiveCategory().then((res) => {
                console.log("hiii")
                console.log(res.data); 
                setCategoriesList(res.data);
        }).catch(err=>console.log(err))
    },[]);
    React.useEffect(() => {
        getActiveProducts().then((res) => {
            console.log("hiii")
            console.log(res.data); 
            setProductList(res.data);
        }).catch(err=>console.log(err))
    },[]);
    const validate = () => {
        let validData = true;
        
        let error = {gst: false,name: false}
        setErr({...err,...error});
        Object.keys(error).map(key => {
            if(formData[key] == "") {
                error[key] = "Field cannot be empty";
                validData = false
            } 
        })
        setErr({...error});

        return validData;
    }
    // SUBMIT
    const onSubmit = () => {
        if(validate()) {
            setLoading(true);
            const url = props.type == "EDIT" ? "/editCoupon" : "/add-coupon"    
            console.log(selectedUsers);
            console.log(selectedProducts);
            console.log(selectedCategories);
            axios({
                method: "post",
                url: url,
                data: {
                    ...formData,
                    userId :selectedUsers && selectedUsers.length > 0 ? selectedUsers:[],
                    productId:selectedApplyType=="Products" && selectedProducts && selectedProducts.length > 0 ? selectedProducts:[],
                    categoryId:selectedApplyType=="Category" && selectedCategories && selectedCategories.length > 0 ? selectedCategories:[],
                    startDate:inputValue,
                    expiryDate:inputEndValue 
                }
            })
            .then(res => {
                if(res.data.success) {
                    props.onDone()
                    setLoading(false);
                    props.setAlert("Succesfully Done")
                    setFormData({couponId: "",
                    couponCode:"",
                    couponType:"FLAT",
                    discountAmount:0,
                    discountPercentage:0,
                    startDate:"",
                    expiryDate:"",
                    usageLimit:1,
                    couponDescription:"",
                    minOrderAmount:"",
                    maxDiscountAmount:"",
                    userId: props.user._id,
                    status:"Active"})
                } else {
                    setLoading(false);
                    props.setAlert("Something went wrong !Try Again")
                }
            }).catch(err => {
                console.log(err)
                setLoading(false)
                props.setAlert("Something went wrong !Try Again")
            })
        }
    }
    const onDateChange = (date, value) => {
        setDate(date);
        setInputValue(value);
    };
    const onDateEndChange = (date, value) => {
        setEndDate(date);
        setInputEndValue(value);
    };
    let btnText = props.type == "EDIT" ? "Update Coupon" : "Add Coupon";

    return (  
        <Dialog open={props.open} onClose={props.onClose} scroll={'paper'} maxWidth={'md'} fullWidth={true}>
            <div className={styles.container}>
                <div className={styles.containerContent}>
                    
                    <div className={styles.header}>
                        <h1>{btnText}</h1>
                        <IconButton onClick={props.onClose}>
                            <CloseRoundedIcon   />
                        </IconButton>
                    </div>

                    <h2>Details</h2>

                    <div className={styles.content}>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Coupon Code"
                                value={formData.couponCode}
                                onBlur={(e) => setFormData({...formData,couponCode: e.target.value.trim()})}

                                onChange={(e) => setFormData({...formData,couponCode: e.target.value})}
                                error={err.couponCode}
                                helperText={err.couponCode}
                            />
                            <SelectComp
                                variant="outlined"
                                className={styles.textField}
                                label="Type"
                                value={formData.couponType}
                                onChange={(e) => setFormData({...formData,couponType: e.target.value})}
                                options={["FLAT","PERCENTAGE"]}
                                values={["FLAT","PERCENTAGE"]}
                            /> 
                        </div>
                        <div className={styles.row}>
                            <TextField
                                variant="outlined"
                                className={styles.textField}
                                label="Discount Amount"
                                value={formData.discountAmount}
                                type="number"
                                onChange={(e) => setFormData({...formData,discountAmount: e.target.value})}
                            />
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Discount Percentage"
                                value={formData.discountPercentage}
                                type="number"
                                onBlur={(e) => setFormData({...formData,discountPercentage: e.target.value.replace(/\D/,'').trim()})}

                                onChange={(e) => {
                                    e.target.value <= 100 && setFormData({...formData,discountPercentage: e.target.value.replace(/\D/,'')})
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                                error={err.discountPercentage}
                                helperText={err.discountPercentage}
                            />
                        </div>
                        <div className={styles.row}>
                            <TextField
                                variant="outlined"
                                className={styles.textField}
                                label="Per User Limit"
                                value={formData.usageLimit}
                                type="number"
                                onChange={(e) => setFormData({...formData,usageLimit: e.target.value})}
                            />
                        </div>
                        <div className={styles.row}>
                            <TextField
                                variant="outlined"
                                className={styles.textField}
                                label="Min Order Amount"
                                value={formData.minOrderAmount}
                                type="number"
                                onChange={(e) => setFormData({...formData,minOrderAmount: e.target.value})}
                            />
                            <TextField
                                variant="outlined"
                                className={styles.textField}
                                label="Max Discount Amount"
                                value={formData.maxDiscountAmount}
                                type="number"
                                onChange={(e) => setFormData({...formData,maxDiscountAmount: e.target.value})}
                            />
                        </div>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textFieldFull}
                                label="Description"
                                value={formData.couponDescription}
                                onBlur={(e) => setFormData({...formData,couponDescription: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,couponDescription: e.target.value})}
                                error={err.couponDescription}
                                helperText={err.couponDescription}
                            />
                            
                        </div>
                        <div className={styles.row}>
                            <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
                            <KeyboardDatePicker
                                autoOk={true}
                                className={styles.textField}
                                label="Start Date"
                                inputVariant="outlined"
                                value={selectedStartDate}
                                format="YYYY-MM-DD"
                                onChange={onDateChange}
                                rifmFormatter={dateFormatter}
                                minDate={moment()}
                                maxDate={moment().add(2, "months")}
                                InputLabelProps={{ shrink: true, required: true }}
                                inputValue={inputValue}
                            />
                            </MuiPickersUtilsProvider>
                            <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
                                <KeyboardDatePicker
                                    autoOk={true}
                                    className={styles.textField}
                                    label="End Date"
                                    inputVariant="outlined"
                                    value={selectedEndDate}
                                    format="YYYY-MM-DD"
                                    onChange={onDateEndChange}
                                    rifmFormatter={dateFormatter}
                                    minDate={inputValue}
                                    maxDate={moment().add(2, "months")}
                                    InputLabelProps={{ shrink: true, required: true }}
                                    inputValue={inputEndValue}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        <div className={styles.row}>
                            <SelectComp
                                variant="outlined"
                                className={styles.textField}
                                label="Status"
                                value={formData.status}
                                onChange={(e) => setFormData({...formData,status: e.target.value})}
                                options={["Active","Inactive"]}
                                values={["Active","Inactive"]}
                            />
                        </div>
                        <h2 style={{marginTop:10,marginBottom:10}}>Specify users for coupon (Default:ALL) </h2>
                        <div className={styles.row}>
                            <Autocomplete
                                multiple
                                id="user-checkboxes"
                                options={userList}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option.name}
                                renderOption={(option, { selected }) => (
                                    <React.Fragment>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.name}
                                    </React.Fragment>
                                )}
                                style={{ width: 400 }}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" label="Select Users" placeholder="Search" />
                                )}
                                onChange={(event, newValue) => {
                                    
                                    console.log(newValue);
                                    console.log('newValue');
                                    console.log(selectedUsers);
                                    if(newValue != null && newValue.length > 0) {
                                        let prevArr = [];
                                        // prevArr = selectedUsers.length <= 0 ? []:selectedUsers;    
                                        // let newArr = [];
                                        let newArr = newValue && newValue.map((user) => user._id);
                                        console.log(newArr);
                                        setSelectedUsers(newArr);
                                    } else {
                                        setSelectedUsers([]);
                                    }
                                    console.log("selectedUsers");
                                }}
                                noOptionsText={'Loading'}
                                loadingText = 'Loading'
                                loading={loadingUser}
                            />
                        </div>
                        <div style={{marginTop:10,marginBottom:10}} className={styles.row}>
                            <SelectComp
                                variant="outlined"
                                className={styles.textField}
                                label="Select Apply Type"
                                value={selectedApplyType}
                                onChange={(e) => setSelectedApplyType(e.target.value)}
                                options={["Category","Products"]}
                                values={["Category","Products"]}
                            />
                        </div>
                        <div className={styles.row}>
                        { selectedApplyType == "Category" &&
                                <Autocomplete
                                    multiple
                                    id="category-checkboxes"
                                    options={categoriesList}
                                    disableCloseOnSelect
                                    getOptionLabel={(option) => option.displayName}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.displayName}
                                        </React.Fragment>
                                    )}
                                    onChange={(event, newValue) => {
                                        console.log('newValue');
                                        console.log(newValue);
                                        if(newValue != null && newValue.length > 0) {
                                            // let prevArr = selectedCategories;
                                            // let newArr = [];
                                            let newArr = newValue.map((cat) => cat._id);
                                            setSelectedCategories(newArr);
                                        } else {
                                            setSelectedCategories([]);
                                        }
                                        console.log("selectedCategories");
                                    }}
                                    style={{ width: 400 }}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Select Categories" placeholder="Search" />
                                    )}
                                />
                            }
                            { selectedApplyType == "Products" &&
                                <Autocomplete
                                    multiple
                                    id="products-checkboxes"
                                    options={productList}
                                    disableCloseOnSelect
                                    getOptionLabel={(option) => option.displayName}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.displayName}
                                        </React.Fragment>
                                    )}
                                    onChange={(event, newValue) => {
                                        console.log('newValue');
                                        console.log(newValue);
                                        if(newValue != null && newValue.length > 0) {
                                            // let prevArr = selectedProducts;
                                            // let newArr = [];
                                            let newArr = newValue.map((product) => product._id);
                                            setSelectedProducts(newArr);
                                        } else {
                                            setSelectedProducts([]);
                                        }
                                        console.log("selectedProducts");
                                    }}
                                    style={{ width: 400 }}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Select Products" placeholder="Search" />
                                    )}
                                />
                            }
                        </div>  

                    </div>

                    <Divider />
 
                     
                    <div className={styles.footer}>
                        {loading 
                            ?
                        <Button variant="contained" color="secondary">
                            Loading....
                        </Button>
                            :
                        <Button variant="contained" color="secondary" onClick={onSubmit}>
                            {btnText}
                        </Button>}
                    </div>
                </div>
            </div>
        </Dialog>  
    )
}

const mapStateToProps = state => ({
    user: state.appReducer.user,
    category: state.appReducer.category,
})
export default withRouter(connect(mapStateToProps,{getCategory})(ConfCoupon));